<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>お客様情報を入力してください。</h1>
          <span>（登録後、変更できます）</span>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              お名前
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="username"
              placeholder="例：山田太郎"
              v-model="params.username"
              :class="{ alert: isEdited.username && error.username }"
            />
            <Alert v-if="isEdited.username && error.username">
              {{ error.username }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              フリガナ
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="userkana"
              placeholder="例：ヤマダタロウ"
              v-model="params.userkana"
              :class="{ alert: isEdited.userkana && error.userkana }"
            />
            <Alert v-if="isEdited.userkana && error.userkana">
              {{ error.userkana }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              企業名
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="company"
              placeholder="例：株式会社PLAN-B"
              v-model="params.company"
              :class="{ alert: isEdited.company && error.company }"
            />
            <Alert v-if="isEdited.company && error.company">
              {{ error.company }}
            </Alert>
            <p class="notes">
              ※企業名がない場合は事業代表者名・団体名などをご入力ください。
            </p>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              電話番号
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="tel"
              v-model="params.tel"
              placeholder="例：000-000-0000"
              :class="{ alert: isEdited.tel && error.tel }"
            />
            <Alert v-if="isEdited.tel && error.tel">
              {{ error.tel }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              メールアドレス
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="email"
              v-model="params.email"
              placeholder="例：sample@example.com"
              :class="{ alert: isEdited.email && error.email }"
            />
            <Alert v-if="isEdited.email && error.email">
              {{ error.email }}
            </Alert>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              パスワード
              <span class="c-required">必須</span>
            </p>
          </div>
          <div
            class="form"
            :class="{ alert: isEdited.password && error.password }"
          >
            <div
              class="c-alertPos"
              :class="{ alert: isEdited.password && error.password }"
            >
              <InputPassword
                name="password"
                v-model="params.password"
                placeholder="例：SampleExample1234@"
              />
              <Alert v-if="isEdited.password && error.password">
                {{ error.password }}
              </Alert>
            </div>
            <p class="notes">
              ※半角英大文字、小文字、数字、記号のうち、3種類以上を含む14文字以上
            </p>
          </div>
        </div>
        <div class="flex">
          <div class="title">
            <p>代理店コード</p>
          </div>
          <div class="form">
            <Input
              name="agentCode"
              v-model="params.agentCode"
              placeholder="代理店コードをお持ちの方は入力してください"
              :disabled="isAgentCodeQuery"
            />
          </div>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
              :disabled="isError"
              @click="confirm"
            >
              確認画面に進む
            </Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import InputPassword from '@/components/InputPassword';
import TitleRegister from '@/components/TitleRegister';
import Progress from '@/components/Progress';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    agentCode: {
      type: String,
      required: false
    }
  },

  components: {
    Alert,
    Button,
    Input,
    InputPassword,
    TitleRegister,
    Progress
  },

  data() {
    // クエリパラメーターで代理店コードが指定されている場合は、初期パラメーターを更新
    const initParams = Object.assign({}, this.$store.state.register.params);
    if (this.agentCode) {
      initParams.agentCode = this.agentCode;
    }

    return {
      error: {
        company: '',
        email: '',
        password: '',
        tel: '',
        userkana: '',
        username: ''
      },
      progress: [
        {
          current: true,
          label: '内容入力'
        },
        {
          label: '内容確認'
        },
        {
          label: '登録完了'
        }
      ],
      params: initParams,
      isEdited: Object.assign({}, this.$store.state.register.isEdited),
      isError: false,
      isAgentCodeQuery: this.agentCode ? true : false
    };
  },

  computed: {
    isTrial() {
      return this.$route.name === 'registerTrial';
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    'params.agentCode': {
      handler(value, oldValue) {
        if (typeof oldValue !== 'undefined') {
          this.isEdited.agentCode = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.email': {
      handler(value, oldValue) {
        this.error.email = new Validation()
          .input()
          .email()
          .test(this.params.email.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.email = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.password': {
      handler(value, oldValue) {
        this.error.password = new Validation()
          .input()
          .password()
          .test(this.params.password);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.password = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.tel': {
      handler(value, oldValue) {
        this.error.tel = new Validation()
          .input()
          .tel()
          .test(this.params.tel.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.tel = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.userkana': {
      handler(value, oldValue) {
        this.error.userkana = new Validation()
          .input()
          .kana()
          .test(this.params.userkana.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.userkana = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.username': {
      handler(value, oldValue) {
        this.error.username = new Validation()
          .input()
          .test(this.params.username.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.username = true;
          this.updateParams();
        }
      },
      immediate: true
    },
    'params.company': {
      handler(value, oldValue) {
        this.error.company = new Validation()
          .input()
          .test(this.params.company.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.company = true;
          this.updateParams();
        }
      },
      immediate: true
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    confirm() {
      if (this.isError) {
        return;
      }
      const routeName = this.isTrial
        ? 'registerTrialConfirm'
        : 'registerConfirm';

      if (this.agentCode) {
        this.$router.push({
          name: routeName,
          query: {
            agentCode: this.agentCode
          }
        });
      } else {
        this.$router.push({ name: routeName });
      }
    },

    updateParams() {
      this.$store.dispatch('register/setParams', this.params);
      this.$store.dispatch('register/setEdited', this.isEdited);
    }
  }
};
</script>
